/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsPackageBuilderViewProps } from './../../../modules/hosports-package-builder/./hosports-package-builder';
import PackageBuilder from './../../../baseComponents/package-builder/./package-builder';

/**
 *
 * HosportsSupportPage component
 * @extends {React.PureComponentReact.Component<IHosportsPackageBuilderProps>}
 */

class HosportsPackageBuilder extends React.Component<IHosportsPackageBuilderViewProps> {

  constructor(props: IHosportsPackageBuilderViewProps) {
      super(props);
  }

  public render(): JSX.Element {
    const { config } = this.props;
    return (
      <PackageBuilder
        active={true}
        year={config.year}
        theme={config.theme}
        columns={config.columns}
      />
    );
  }
}

export default HosportsPackageBuilder;
